import styled from "styled-components";

import { OfficePhotos } from "./OfficePhotos";

import { Spacing, Text } from "@otta/design";
import { Company } from "@otta/search/schema";
import { breakpoints, palette, pxToRem } from "@otta/design-tokens";
import { Link } from "@otta/search/components/Link";

const CardOfficeMap = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${palette.grayscale.shade100};
  border-radius: ${pxToRem(12)};
  background-color: ${palette.brand.white};
  overflow: hidden;
`;

const MapWrapper = styled.div`
  position: relative;
`;

const MapImg = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  width: auto;
`;

const MapSource = styled.source(MapImg);

const MapAddress = styled(Text)`
  padding: ${pxToRem(16)};
  word-wrap: break-word;
  overflow-wrap: break-word;
  border-top: 1px solid ${palette.grayscale.shade100};

  :hover {
    background-color: ${palette.grayscale.shade50};
    transition: background-color 0.2s;
  }
`;

export const shouldDisplayCompanyOffice = (company: Company.Company) => {
  return company.offices?.length !== 0 && company.offices?.at(0);
};

export const CompanyOffice = ({ company }: { company: Company.Company }) => {
  if (
    !shouldDisplayCompanyOffice(company) ||
    // Already checked in shouldDisplayCompanyOffice but TS doesn't know
    !company.offices
  ) {
    return null;
  }

  const office = company.offices.at(0);
  const mapUrl = `https://www.google.com/maps/search/${office?.address}`;

  return (
    <div data-testid="office">
      <Spacing>
        <Text bold size={1}>
          Office
        </Text>
        <Spacing>
          <CardOfficeMap>
            <Link
              to={mapUrl}
              underline={false}
              data-analytics-id="company-page-office-map"
            >
              <MapWrapper>
                <picture>
                  <MapSource
                    type="image/webp"
                    media={`(min-width: ${pxToRem(breakpoints.tablet)})`}
                    srcSet={office?.mapImageUrls.large}
                  />
                  <MapImg
                    srcSet={office?.mapImageUrls.medium}
                    alt={`${company.name} Google Maps office location`}
                    loading="lazy"
                  />
                </picture>
                <MapAddress>{office?.address}</MapAddress>
              </MapWrapper>
            </Link>
          </CardOfficeMap>
          <OfficePhotos company={company} />
        </Spacing>
      </Spacing>
    </div>
  );
};
